const isDev = process.env.NODE_ENV === 'development';

const logger = {
    /**
     * Logs informational messages (dev only)
     */
    log: (...args) => {
        if (isDev) {
            // eslint-disable-next-line no-console
            console.log(...args);
        }
    },

    /**
     * Logs warning messages (dev only)
     */
    warn: (...args) => {
        if (isDev) {
            // eslint-disable-next-line no-console
            console.warn(...args);
        }
    },

    /**
     * Logs error messages (dev only)
     */
    error: (...args) => {
        if (isDev) {
            // eslint-disable-next-line no-console
            console.error(...args);
        }
    },

    /**
     * Logs debug messages (dev only)
     */
    debug: (...args) => {
        if (isDev) {
            // eslint-disable-next-line no-console
            console.debug(...args);
        }
    },
};

export default logger;
